import { Component, OnInit } from '@angular/core';
import { slideLeft, slideUp, slideRight } from '../animations';

@Component({
  selector: 'app-projects',
  templateUrl: './projects.component.html',
  styleUrls: ['./projects.component.css'],
  animations: [
    slideLeft,
    slideUp,
    slideRight
  ]
})
export class ProjectsComponent implements OnInit {

  projects =  [
    {
      title: "The Game Catalog",
      description: "A web application that uses a JavaScript library (jQuery UI), a CSS framework (Bootstrap), two remote APIs (GiantBomb and Youtube API). Deployed on Firebase.",
      app: "It's a video game catalog where you can see the games for each console for a specific month/year.",
      link: "https://thegamecat-1e92e.web.app/",
      video: "../assets/gamecat.gif",
      logo: "",
      tech: '',
      repo: "https://github.com/jmelegrito/Phase-1-Group-Project"
    },
    {
      title: "The Stand App",
      description: "A full-stack web application that uses Express, PostgreSQL, and Sequelize for ORM. It has a PassportJS Local Strategy and incorporates an OAuth Provider (Google OAuth2.o0) with HTML templating (EJS). Finally it was deployed to the cloud (Heroku).",
      app: "It's The Stand Up App! Featuring individual tasks and group tasks for use during daily stand up meetings, our app will assist in getting the conversation flowing in 5 minutes or less. Update and delete tasks easily.",
      link: "https://standapplication.herokuapp.com",
      video: "../assets/standapp.gif",
      logo: "",
      tech:'',
      repo: "https://github.com/jmelegrito/stand-app"
    },
    {
      title: "The On-The-Day Scheduler",
      description: "A tool created to assist rehab directors schedule their therapy-patient visits and provide a view according to therapist and patient. Entirely front-end written in React with Redux and Bootstrap. Deployed to Heroku.",
      app: "It's a Single Page Application (SPA) designed to help Rehab Directors keep track of the Rehab Team's daily schedule. This allows them to make sense of which patient is assigned to which therapist and when.",
      link: "https://on-the-day-scheduler.herokuapp.com/",
      video: "",
      logo: "",
      tech:'',
      repo: "https://github.com/jmelegrito/on-the-day-scheduler-react-redux"
    },
    {
      title: "The Tournament Planner",
      description: "A SPA created to assist eSports organizers set up tournaments and allow participants to check their round progress. Written in Angular with Material UI. Node.js, Sequelize with PostgreSQL, and Passport for the back-end and database.",
      app: "With the idea of building a functional productivity app that aligns with our interests, we created the Tournament Planner App. It lets you organize tournaments that could be anything from a basketball tourney to an esports one.",
      link: "https://tourney-planner.herokuapp.com/",
      video: "",
      logo: "",
      tech:'',
      repo: "https://github.com/jmelegrito/tournament-planner"
    }

  ]

  constructor() { }

  ngOnInit() {
  }

}
